<template>
    <div>
        <BACK title="編輯徵才/求職" name='Home'/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="新增類別" prop="interviewType">
                <div class="clear">
                    <el-checkbox v-for="({interviewType, interviewName},idx) in jobType" v-model="interviewOption[idx]"
                                 :key="idx" @change="chengeJobType(idx)">{{interviewName}}
                    </el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="選擇地區" prop="areaId">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaId"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="薪水區間" prop="pay">
                <div class="flex">
                    <el-input v-model="form.payFrom" type="number" :value="form.payFrom" clearable placeholder="不限" oninput="if(value.length>5)value=value.slice(0,8)"/>
                    <span class="text_pad color_primary">到</span>
                    <el-input v-model="form.payTo" type="number" clearable placeholder="不限" oninput="if(value.length>5)value=value.slice(0,8)"/>
                </div>
            </el-form-item>
            <el-form-item label="聯絡姓名" prop="contactName">
                <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡人名稱"></el-input>
            </el-form-item>
            <el-form-item label="聯絡資訊" prop="contactMemo">
                <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡資訊"></el-input>
            </el-form-item>
            <el-form-item label="徵才/求職標題" prop="title">
                <el-input v-model="form.title" type="text" oninput="value=value.replace(value.slice(20),'')" clearable
                          placeholder="輸入標題"></el-input>
            </el-form-item>
            <el-form-item label="內容敘述" prop="content">
                <el-input v-model="form.content" type="textarea"></el-input>
            </el-form-item>
        </el-form>
        <div class="note">*文章均遵守<span class="tag" @click="openTerms">《服務條款》</span></div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="handleSubmit()">
                <i class="el-icon-loading" v-if="loading"></i>送出
            </el-button>
        </div>
    </div>
</template>
<script>

    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'add',
        components: {
            BACK
        },
        mixins: [FN],
        data() {
            return {
                interviewOption: {
                    0: false,
                    1: false
                },
                form: {
                    title: '',
                    areaId: 1,
                    payTo: '',
                    payFrom: '',
                    pay: '',
                    interviewType: '',
                    content: '',
                    contactName: '',
                    contactMemo: ''
                }
            }
        },
        mounted() {
            //取得資料並寫入
            this.getDetail()
        },
        computed: {
            ...mapGetters([
                'jobType',
                'searchArea',
                'jobDetail'
            ]),
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-interviewType
                const isinterviewType = (rule, value, callback) => {
                    if (!this.interviewOption[0] && !this.interviewOption[1]) {
                        callback(new Error('請選擇徵才類別'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-Pay
                const isPay = (rule, value, callback) => {
                    if (this.form.payTo && +this.form.payTo < +this.form.payFrom) {
                        callback(new Error('最高月薪不可低於最低月資'))
                    } else {
                        callback()
                    }
                }
                return {
                    interviewType: [
                        {required: true, trigger: 'change', validator: isinterviewType}
                    ],
                    areaId: [{required: true, trigger: 'change', message}],
                    title: [{required: true, trigger: 'change', message: "請輸入標題"}],
                    content: [{required: true, trigger: 'change', message: '請輸入內容敘述'}],
                    pay: [
                        {required: false, trigger: 'change', validator: isPay}
                    ],
                    contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
                    contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
                }
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            chengeJobType(idx) {
                if (this.interviewOption[idx]) {
                    this.interviewOption[Math.abs(idx - 1)] = false
                    this.interviewType = this.interviewOption[idx]
                }
            },
            beforeFormSubmit() {
            },
            //送出表單
            handleSubmit() {
                const id = this.$route.params.id
                const form = this.$refs.form
                console.log("fomr",this.form );
                this.beforeValidate()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'JOB_EDIT',
                            id: id,
                            areaId: this.form.areaId,
                            interviewType: this.interviewOption[0] ? 1 : 2,
                            title: this.form.title,
                            payFrom: this.form.payFrom || '',
                            payTo: this.form.payTo || '',
                            content: this.form.content,
                            contactName: this.form.contactName,
                            contactMemo: this.form.contactMemo
                        }).then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSubmit)
                            } else {
                                this.handleResponse(res)
                            }
                        })
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }
                })

            },
            //回應
            handleResponse(res) {
                //const id = this.$route.params.id
                if (!+res.code) {
                    this.$confirm('修改成功', {
                        closeOnClickModal: false,
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
                            // window.open(href, '_self')
                            this.$router.replace({name: 'Job', params: {tag: 'my'}})
                            this.$parent.handleSearch()
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getDetail() {
                const id = this.$route.params.id
                this.FETCH({
                    key: 'JOB_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                    if (!+res) {
                        this.form = {
                            ...this.form,
                            ...this.jobDetail
                        }
                        this.interviewOption[+this.jobDetail.interviewType - 1] = true
                        this.form.payTo = parseInt(this.form.payTo)
                        this.form.payFrom = parseInt(this.form.payFrom)
                    }
                })
            },
            openTerms() {
                this.$parent.dialogVisible = true
            },
            handleBack() {
                const id = this.$route.params.id
                this.$router.replace({name: 'JobDetails', params: {id: id}})
            }
        }
    }
</script>
